import React from 'react';
import { FaRocket, FaLightbulb, FaHeart } from 'react-icons/fa';

export default function ReachPotentialSection() {
    return (
        <section className="py-20 bg-gray-900 relative overflow-hidden">
            {/* Modern Background Pattern */}
            <div className="absolute inset-0">
                <div className="absolute top-20 left-20 w-32 h-32 bg-blue-500/10 rounded-full blur-xl"></div>
                <div className="absolute bottom-32 right-32 w-40 h-40 bg-white/5 rounded-full blur-xl"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-600/5 rounded-full blur-2xl"></div>
            </div>

            <div className="relative max-w-6xl mx-auto px-6">
                <div className="grid md:grid-cols-2 gap-12 items-center">
                    {/* Content Side */}
                    <div>
                        <div className="inline-block mb-6">
                            <div className="flex items-center gap-2 bg-blue-500/20 border border-blue-400/30 rounded-2xl px-6 py-3">
                                <FaRocket className="text-blue-400 text-lg" />
                                <span className="text-blue-200 font-semibold text-sm lemon-milk">TRANSFORM YOUR FUTURE</span>
                            </div>
                        </div>

                        <h2 className="text-3xl md:text-4xl font-black text-white mb-6 leading-tight lemon-milk">
                            Reach Your Potential with{' '}
                            <span className="text-blue-400">
                                Sudesh Maths
                            </span>
                        </h2>

                        <p className="text-lg text-gray-300 mb-8 leading-relaxed poppins">
                            Our comprehensive learning platform is designed to accelerate your academic growth.
                            Master cutting-edge subjects with expert instructors and build knowledge that matters.
                        </p>

                        {/* Feature List */}
                        <div className="space-y-6 mb-8">
                            <div className="flex items-center gap-4">
                                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center shadow-lg">
                                    <FaLightbulb className="text-white text-lg" />
                                </div>
                                <div>
                                    <h4 className="text-white font-bold text-lg lemon-milk">Interactive Learning Experience</h4>
                                    <p className="text-gray-400 text-sm poppins">Engage with dynamic content and real-time feedback</p>
                                </div>
                            </div>

                            <div className="flex items-center gap-4">
                                <div className="w-12 h-12 bg-gray-600 rounded-lg flex items-center justify-center shadow-lg">
                                    <FaRocket className="text-white text-lg" />
                                </div>
                                <div>
                                    <h4 className="text-white font-bold text-lg lemon-milk">Career-Focused Curriculum</h4>
                                    <p className="text-gray-400 text-sm poppins">Learn skills that directly impact your future success</p>
                                </div>
                            </div>

                            <div className="flex items-center gap-4">
                                <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center shadow-lg">
                                    <FaHeart className="text-white text-lg" />
                                </div>
                                <div>
                                    <h4 className="text-white font-bold text-lg lemon-milk">Supportive Learning Community</h4>
                                    <p className="text-gray-400 text-sm poppins">Connect with peers and mentors who inspire growth</p>
                                </div>
                            </div>
                        </div>

                        {/* CTA Button */}
                        <button className="bg-blue-600 text-white px-8 py-4 rounded-lg font-bold hover:bg-blue-700 transition-colors shadow-lg lemon-milk">
                            Start Your Journey Today
                        </button>
                    </div>

                    {/* Image Side */}
                    <div className="relative">
                        <div className="absolute inset-0 bg-blue-600/20 rounded-2xl blur-xl transform rotate-3"></div>
                        <div className="relative bg-white rounded-2xl p-3 shadow-xl">
                            <img
                                src="hero/1.jpg"
                                alt="Students learning together"
                                className="rounded-xl w-full h-auto"
                            />
                        </div>

                        {/* Floating Stats */}
                        <div className="absolute -top-4 -right-4 bg-white rounded-xl p-4 shadow-xl">
                            <div className="text-center">
                                <div className="text-2xl font-black text-blue-600 lemon-milk">98%</div>
                                <div className="text-xs text-gray-600 poppins">Success Rate</div>
                            </div>
                        </div>

                        <div className="absolute -bottom-4 -left-4 bg-white rounded-xl p-4 shadow-xl">
                            <div className="text-center">
                                <div className="text-2xl font-black text-gray-700 lemon-milk">10K+</div>
                                <div className="text-xs text-gray-600 poppins">Students</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
